import { a as Y, c as z, _ as M, k as pe, s as ve, f as ye } from "./createTheme-02ce03eb.js";
import Se from "@emotion/styled";
import "@emotion/react";
var D = {}, _e = {
  get exports() {
    return D;
  },
  set exports(e) {
    D = e;
  }
}, o = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var U;
function Ee() {
  if (U)
    return o;
  U = 1;
  var e = Symbol.for("react.element"), n = Symbol.for("react.portal"), u = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), c = Symbol.for("react.profiler"), f = Symbol.for("react.provider"), y = Symbol.for("react.context"), S = Symbol.for("react.server_context"), l = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), _ = Symbol.for("react.suspense_list"), p = Symbol.for("react.memo"), R = Symbol.for("react.lazy"), x = Symbol.for("react.offscreen"), P;
  P = Symbol.for("react.module.reference");
  function v(t) {
    if (typeof t == "object" && t !== null) {
      var T = t.$$typeof;
      switch (T) {
        case e:
          switch (t = t.type, t) {
            case u:
            case c:
            case i:
            case m:
            case _:
              return t;
            default:
              switch (t = t && t.$$typeof, t) {
                case S:
                case y:
                case l:
                case R:
                case p:
                case f:
                  return t;
                default:
                  return T;
              }
          }
        case n:
          return T;
      }
    }
  }
  return o.ContextConsumer = y, o.ContextProvider = f, o.Element = e, o.ForwardRef = l, o.Fragment = u, o.Lazy = R, o.Memo = p, o.Portal = n, o.Profiler = c, o.StrictMode = i, o.Suspense = m, o.SuspenseList = _, o.isAsyncMode = function() {
    return !1;
  }, o.isConcurrentMode = function() {
    return !1;
  }, o.isContextConsumer = function(t) {
    return v(t) === y;
  }, o.isContextProvider = function(t) {
    return v(t) === f;
  }, o.isElement = function(t) {
    return typeof t == "object" && t !== null && t.$$typeof === e;
  }, o.isForwardRef = function(t) {
    return v(t) === l;
  }, o.isFragment = function(t) {
    return v(t) === u;
  }, o.isLazy = function(t) {
    return v(t) === R;
  }, o.isMemo = function(t) {
    return v(t) === p;
  }, o.isPortal = function(t) {
    return v(t) === n;
  }, o.isProfiler = function(t) {
    return v(t) === c;
  }, o.isStrictMode = function(t) {
    return v(t) === i;
  }, o.isSuspense = function(t) {
    return v(t) === m;
  }, o.isSuspenseList = function(t) {
    return v(t) === _;
  }, o.isValidElementType = function(t) {
    return typeof t == "string" || typeof t == "function" || t === u || t === c || t === i || t === m || t === _ || t === x || typeof t == "object" && t !== null && (t.$$typeof === R || t.$$typeof === p || t.$$typeof === f || t.$$typeof === y || t.$$typeof === l || t.$$typeof === P || t.getModuleId !== void 0);
  }, o.typeOf = v, o;
}
var s = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var K;
function he() {
  return K || (K = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Symbol.for("react.element"), n = Symbol.for("react.portal"), u = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), c = Symbol.for("react.profiler"), f = Symbol.for("react.provider"), y = Symbol.for("react.context"), S = Symbol.for("react.server_context"), l = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), _ = Symbol.for("react.suspense_list"), p = Symbol.for("react.memo"), R = Symbol.for("react.lazy"), x = Symbol.for("react.offscreen"), P = !1, v = !1, t = !1, T = !1, A = !1, E;
    E = Symbol.for("react.module.reference");
    function $(r) {
      return !!(typeof r == "string" || typeof r == "function" || r === u || r === c || A || r === i || r === m || r === _ || T || r === x || P || v || t || typeof r == "object" && r !== null && (r.$$typeof === R || r.$$typeof === p || r.$$typeof === f || r.$$typeof === y || r.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      r.$$typeof === E || r.getModuleId !== void 0));
    }
    function d(r) {
      if (typeof r == "object" && r !== null) {
        var j = r.$$typeof;
        switch (j) {
          case e:
            var L = r.type;
            switch (L) {
              case u:
              case c:
              case i:
              case m:
              case _:
                return L;
              default:
                var W = L && L.$$typeof;
                switch (W) {
                  case S:
                  case y:
                  case l:
                  case R:
                  case p:
                  case f:
                    return W;
                  default:
                    return j;
                }
            }
          case n:
            return j;
        }
      }
    }
    var C = y, g = f, I = e, a = l, h = u, b = R, w = p, V = n, F = c, B = i, J = m, Q = _, k = !1, q = !1;
    function ee(r) {
      return k || (k = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function te(r) {
      return q || (q = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function re(r) {
      return d(r) === y;
    }
    function ne(r) {
      return d(r) === f;
    }
    function oe(r) {
      return typeof r == "object" && r !== null && r.$$typeof === e;
    }
    function se(r) {
      return d(r) === l;
    }
    function ie(r) {
      return d(r) === u;
    }
    function ce(r) {
      return d(r) === R;
    }
    function ae(r) {
      return d(r) === p;
    }
    function ue(r) {
      return d(r) === n;
    }
    function fe(r) {
      return d(r) === c;
    }
    function le(r) {
      return d(r) === i;
    }
    function de(r) {
      return d(r) === m;
    }
    function me(r) {
      return d(r) === _;
    }
    s.ContextConsumer = C, s.ContextProvider = g, s.Element = I, s.ForwardRef = a, s.Fragment = h, s.Lazy = b, s.Memo = w, s.Portal = V, s.Profiler = F, s.StrictMode = B, s.Suspense = J, s.SuspenseList = Q, s.isAsyncMode = ee, s.isConcurrentMode = te, s.isContextConsumer = re, s.isContextProvider = ne, s.isElement = oe, s.isForwardRef = se, s.isFragment = ie, s.isLazy = ce, s.isMemo = ae, s.isPortal = ue, s.isProfiler = fe, s.isStrictMode = le, s.isSuspense = de, s.isSuspenseList = me, s.isValidElementType = $, s.typeOf = d;
  }()), s;
}
(function(e) {
  process.env.NODE_ENV === "production" ? e.exports = Ee() : e.exports = he();
})(_e);
const Re = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function Te(e) {
  const n = `${e}`.match(Re);
  return n && n[1] || "";
}
function H(e, n = "") {
  return e.displayName || e.name || Te(e) || n;
}
function X(e, n, u) {
  const i = H(n);
  return e.displayName || (i !== "" ? `${u}(${i})` : u);
}
function be(e) {
  if (e != null) {
    if (typeof e == "string")
      return e;
    if (typeof e == "function")
      return H(e, "Component");
    if (typeof e == "object")
      switch (e.$$typeof) {
        case D.ForwardRef:
          return X(e, e.render, "ForwardRef");
        case D.Memo:
          return X(e, e.type, "memo");
        default:
          return;
      }
  }
}
/**
 * @mui/styled-engine v5.11.11
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
function $e(e, n) {
  const u = Se(e, n);
  return process.env.NODE_ENV !== "production" ? (...i) => {
    const c = typeof e == "string" ? `"${e}"` : "component";
    return i.length === 0 ? console.error([`MUI: Seems like you called \`styled(${c})()\` without a \`style\` argument.`, 'You must provide a `styles` argument: `styled("div")(styleYouForgotToPass)`.'].join(`
`)) : i.some((f) => f === void 0) && console.error(`MUI: the styled(${c})(...args) API requires all its args to be defined.`), u(...i);
  } : u;
}
const Pe = (e, n) => {
  Array.isArray(e.__emotion_styles) && (e.__emotion_styles = n(e.__emotion_styles));
}, Ce = ["variant"];
function G(e) {
  return e.length === 0;
}
function Z(e) {
  const {
    variant: n
  } = e, u = Y(e, Ce);
  let i = n || "";
  return Object.keys(u).sort().forEach((c) => {
    c === "color" ? i += G(i) ? e[c] : z(e[c]) : i += `${G(i) ? c : z(c)}${z(e[c].toString())}`;
  }), i;
}
const we = ["name", "slot", "skipVariantsResolver", "skipSx", "overridesResolver"], xe = ["theme"], Fe = ["theme"];
function N(e) {
  return Object.keys(e).length === 0;
}
function Me(e) {
  return typeof e == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  e.charCodeAt(0) > 96;
}
const Ne = (e, n) => n.components && n.components[e] && n.components[e].styleOverrides ? n.components[e].styleOverrides : null, Oe = (e, n) => {
  let u = [];
  n && n.components && n.components[e] && n.components[e].variants && (u = n.components[e].variants);
  const i = {};
  return u.forEach((c) => {
    const f = Z(c.props);
    i[f] = c.style;
  }), i;
}, Ae = (e, n, u, i) => {
  var c, f;
  const {
    ownerState: y = {}
  } = e, S = [], l = u == null || (c = u.components) == null || (f = c[i]) == null ? void 0 : f.variants;
  return l && l.forEach((m) => {
    let _ = !0;
    Object.keys(m.props).forEach((p) => {
      y[p] !== m.props[p] && e[p] !== m.props[p] && (_ = !1);
    }), _ && S.push(n[Z(m.props)]);
  }), S;
};
function O(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
const ge = pe(), Ie = (e) => e.charAt(0).toLowerCase() + e.slice(1);
function Le(e = {}) {
  const {
    defaultTheme: n = ge,
    rootShouldForwardProp: u = O,
    slotShouldForwardProp: i = O
  } = e, c = (f) => {
    const y = N(f.theme) ? n : f.theme;
    return ve(M({}, f, {
      theme: y
    }));
  };
  return c.__mui_systemSx = !0, (f, y = {}) => {
    Pe(f, (E) => E.filter(($) => !($ != null && $.__mui_systemSx)));
    const {
      name: S,
      slot: l,
      skipVariantsResolver: m,
      skipSx: _,
      overridesResolver: p
    } = y, R = Y(y, we), x = m !== void 0 ? m : l && l !== "Root" || !1, P = _ || !1;
    let v;
    process.env.NODE_ENV !== "production" && S && (v = `${S}-${Ie(l || "Root")}`);
    let t = O;
    l === "Root" ? t = u : l ? t = i : Me(f) && (t = void 0);
    const T = $e(f, M({
      shouldForwardProp: t,
      label: v
    }, R)), A = (E, ...$) => {
      const d = $ ? $.map((a) => typeof a == "function" && a.__emotion_real !== a ? (h) => {
        let {
          theme: b
        } = h, w = Y(h, xe);
        return a(M({
          theme: N(b) ? n : b
        }, w));
      } : a) : [];
      let C = E;
      S && p && d.push((a) => {
        const h = N(a.theme) ? n : a.theme, b = Ne(S, h);
        if (b) {
          const w = {};
          return Object.entries(b).forEach(([V, F]) => {
            w[V] = typeof F == "function" ? F(M({}, a, {
              theme: h
            })) : F;
          }), p(a, w);
        }
        return null;
      }), S && !x && d.push((a) => {
        const h = N(a.theme) ? n : a.theme;
        return Ae(a, Oe(S, h), h, S);
      }), P || d.push(c);
      const g = d.length - $.length;
      if (Array.isArray(E) && g > 0) {
        const a = new Array(g).fill("");
        C = [...E, ...a], C.raw = [...E.raw, ...a];
      } else
        typeof E == "function" && // On the server Emotion doesn't use React.forwardRef for creating components, so the created
        // component stays as a function. This condition makes sure that we do not interpolate functions
        // which are basically components used as a selectors.
        E.__emotion_real !== E && (C = (a) => {
          let {
            theme: h
          } = a, b = Y(a, Fe);
          return E(M({
            theme: N(h) ? n : h
          }, b));
        });
      const I = T(C, ...d);
      if (process.env.NODE_ENV !== "production") {
        let a;
        S && (a = `${S}${l || ""}`), a === void 0 && (a = `Styled(${be(f)})`), I.displayName = a;
      }
      return I;
    };
    return T.withConfig && (A.withConfig = T.withConfig), A;
  };
}
const Ye = ye(), De = Ye, Ve = (e) => O(e) && e !== "classes", We = O, je = Le({
  defaultTheme: De,
  rootShouldForwardProp: Ve
}), Ue = je;
export {
  Ve as a,
  We as b,
  $e as c,
  De as d,
  D as r,
  Ue as s
};
